/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetFreeeConnectionSettingsForAccounting200Response
 */
export interface GetFreeeConnectionSettingsForAccounting200Response {
    /**
     * 
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'orgAccountId': string;
    /**
     * freee事業所ID
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'freeeCompanyId': string;
    /**
     * freee事業所名
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'freeeCompanyName': string;
    /**
     * 口座の連携単位
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'cardWalletableUnit': GetFreeeConnectionSettingsForAccounting200ResponseCardWalletableUnitEnum;
    /**
     * 連携日時
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'connectedAt': string;
    /**
     * 連携開始日時(yyyy-MM-dd)
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'syncStartDate': string;
    /**
     * リフレッシュトークンが失効する日時 (ex. 2026-01-27T02:10:08.614521)
     * @type {string}
     * @memberof GetFreeeConnectionSettingsForAccounting200Response
     */
    'refreshTokenExpiredAt': string;
}

export const GetFreeeConnectionSettingsForAccounting200ResponseCardWalletableUnitEnum = {
    single: 'SINGLE',
    group: 'GROUP',
    all: 'ALL'
} as const;

export type GetFreeeConnectionSettingsForAccounting200ResponseCardWalletableUnitEnum = typeof GetFreeeConnectionSettingsForAccounting200ResponseCardWalletableUnitEnum[keyof typeof GetFreeeConnectionSettingsForAccounting200ResponseCardWalletableUnitEnum];


